import { WarningIcon } from "@chakra-ui/icons";
import { Flex, Text } from "@chakra-ui/react";

interface RanaWarningTextProps {
  message: string;
  show: boolean;
}

export const RanaWarningText = (props: RanaWarningTextProps) => {
  const { message, show } = props;

  return (
    <Flex
      borderWidth="base"
      borderColor="semantic.warning.main"
      bgColor="semantic.warning.background"
      p={4}
      borderRadius="base"
      gap={2}
      display={show ? "flex" : "none"}
    >
      <WarningIcon color="semantic.warning.main" boxSize={6} />
      <Text textStyle="md" color="semantic.warning.main" fontWeight={300}>
        {message}
      </Text>
    </Flex>
  );
};
